import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';

export function stopRecordingEvent() {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.STOP_RECORDING,
  };

  pushToDataLayer({
    ...eventAttributes,
  });
}
